// extracted by mini-css-extract-plugin
export default {"result":"correctHoardPriceModal_result__vh6E9"};